// Constants for different requests for current reducer
export default {
  adminTab: 'ADMIN_TAB',
};
